import React, { Component } from 'react';
import SelectedSideDishListing from '../../app/User/Order/SelectedSideDishListing';
import SelectedVariationListing from '../../app/User/Order/SelectedVariationListing';
import { OrderStyle } from '../../components/merchant/components/WaiterOrder/AdminOrder';
import { sortBySetNumber, setNumberHeader } from '../../Model/Order';
import NoDiscountText from './NoDiscountText';

const NoDiscountHint = ({bill,order}) => {
    const a = bill && bill.voucher_history_id &&
        <NoDiscountText order={order} />
    return a || null
}

class OrderListModal extends Component {
    constructor(props) {
        super(props);
        this.state = {};
    }
    componentDidMount(){

    }

    getMenuItemName(itemId) {
        let menuItem = this.props.menuItems.find((item) => item.id == itemId)
        return menuItem.name;
    }
    getSideDishes = (order) => {
        let sideDishSelection = []
        if (order.side_dish_data && order.side_dish_data.selections && Array.isArray(order.side_dish_data.selections)) {
            sideDishSelection = order.side_dish_data.selections
        }
        return sideDishSelection.map((sd, index) => {
            return <div key={index}>
                &bull; {sd.variation.name}
                {sd.quantity > 1 && ` x ${sd.quantity}`}
            </div>
        })
    }
    getOrderDescription(order) {
        let isOnlineOrder = this.props.tableSession && this.props.tableSession.pickup
        return (
            <div className={'clearfix'} style={{ marginBottom: "5px" }}>
                <div>
                    <div className={'pull-left'}>
                        <div className={'btn-group mr-2'} role="group" aria-label="Second group" style={{ display: "inline-block" }}>
                            <SelectedSideDishListing app={this.props.app} order={order} />
                            <SelectedVariationListing app={this.props.app} order={order} />
                            <span style={{ display: order.remark ? "block" : "none" }}>{lang.remark + ": " + order.remark}</span>
                            {
                                !isOnlineOrder && <span><span>&#10033;</span>{order.take_away? lang.take_away : lang.dine_in}</span>
                            }
                            <div style={{fontSize:"0.8em"}}><NoDiscountHint order={order} bill={this.props.bill}/></div>
                        </div>
                    </div>
                </div>
            </div>
        )
    }

    getItemPrice = (order) => {
        let components = []
        const discount = parseFloat(order.total_discount) || 0
        const discountedPrice = order.order_total - discount
        components.push(<span key={1}>{this.props.app.state.currencyName+" " + discountedPrice.toFixed(2)}</span>)
        if (discount) {
            components.push(<br key={2}/>)
            components.push(<span key={3} style={{textDecoration:"line-through", fontSize: "10pt"}}>{this.props.app.state.currencyName+" " + (order.order_total * 1).toFixed(2)}</span>)
        }
        return components
    }
    orderList(){
        let me = this
        let index = 0

        if (!this.props.orders || !this.props.menuItems) {
            return;
        }

        let confirmOrder = this.props.orders.filter((order) => order.order_status == "accepted" || order.order_status == "closed")
        let li = []

        const tableSession = this.props.tableSession
        const isOrderSetBySet = tableSession && tableSession.extra_data && tableSession.extra_data.order_style == OrderStyle.SET_BY_SET
        if (isOrderSetBySet) {
            sortBySetNumber(confirmOrder)
        }

        let lastOrder = null
        let currentSetNumber = 1
        confirmOrder.forEach((order) => {
            order.item_name = me.getMenuItemName(order.menu_item_id);
            let listClass = "confirm-order-" + order.id;
            index++;

            if (isOrderSetBySet) {
                const headerSetNumber = setNumberHeader(lastOrder, order, currentSetNumber, (setNumber, nextLastOrder) => {
                    currentSetNumber = setNumber
                    lastOrder = nextLastOrder
                })
                if (headerSetNumber) {
                    li.push(<div key={`set-${headerSetNumber}`}>
                        <strong><u>Set {headerSetNumber}</u></strong>
                    </div>)
                }
            }

            li.push(
                <div className={listClass} key={listClass}>
                    <li className={'list-group-item clearfix'} data-index={index} style={{ verticalAlign: "middle" }} key={order.id} data-id={order.id}>
                        <div style={{ fontSize: "20px", fontWeight: "bold" }}>
                            {order.quantity + "x " + order.desc}
                            <div className="pull-right" style={{textAlign:"right"}}>
                                {this.getItemPrice(order)}
                            </div>
                        </div>
                        {this.getOrderDescription(order)}
                        {/* <div style={{position:"absolute", bottom: "-2px", left:"5px", width:"100%", fontSize: "8pt"}}>
                            <NoDiscountText order={order}/>
                        </div> */}
                    </li>
                </div>
            )
        })
        return li
    }

    render() {
        return (
            <div className="modal fade" id={this.props.id? this.props.id: "orderListModal"} tabIndex="-1" role="dialog" aria-labelledby="orderListModalLabel" aria-hidden="true">
                <div className="modal-dialog" role="document">
                    <div className="modal-content">
                        <div className="modal-body">
                            {
                                this.props.showRefNo &&
                                <div>
                                    {this.props.app.state.current_session && (lang.ref_no + ": " + this.props.app.state.current_session.id)}
                                </div>
                            }
                            {this.props.body? this.props.body: this.orderList()}
                        </div>
                        <div className="modal-footer">
                            <button type="button" className="btn btn-secondary" data-dismiss="modal">{lang.close}</button>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}

export default OrderListModal;